var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-sod-eod-history"},[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('SodEodFullReport')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }